/**
 *  階層2の表示件数
 */
export const KAISO2_LIST_CNT = 10
/**
 *  階層3の表示件数
 */
export const KAISO3_LIST_CNT = 5
/**
 * リポジトリへの検索URL(外部サイト)
 */
//export const REPO_URL = 'http://ir.lib.u-ryukyu.ac.jp/simple-search'
export const REPO_URL = 'http://ir.lib.u-ryukyu.ac.jp/handle/20.500.12000/43107/simple-search'
